module.exports = __webpack_public_path__ + "static/media/daisyChain.564da0f8.png";